import {
  IUserPrivileges,
  IFacilityInformation,
} from 'src/app/models/service/user-privileges.model';

export class ASetUserPrivileges {
  static readonly type = '[UserPrivileges] ASetUserPrivileges]';
  constructor(public readonly payload?: IUserPrivileges) {}
}

export class ASetAdminFacilitiesId {
  static readonly type = '[AdminFacilitiesId] ASetAdminFacilitiesId]';
  constructor(public readonly payload?: IFacilityInformation[]) {}
}
